module.exports = __webpack_public_path__ + "static/media/olga.3ad4ec9f.jpg";